import { render, staticRenderFns } from "./Infomation.vue?vue&type=template&id=de13ff9e&scoped=true"
import script from "./Infomation.vue?vue&type=script&lang=js"
export * from "./Infomation.vue?vue&type=script&lang=js"
import style0 from "./Infomation.vue?vue&type=style&index=0&id=de13ff9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de13ff9e",
  null
  
)

export default component.exports